import { Box } from "@/components/layout/flexbox";
import { SettingsLayout } from "@/components/nav/SettingsLayout";
import { Authenticate } from "@/components/pages_logged_in/Authenticate";
import { FirefliesIntegration } from "@/components/pages_logged_in/integrations/FirefliesIntegration";
import { GongIntegration } from "@/components/pages_logged_in/integrations/GongIntegration";
import { Container } from "@/components/pieces/bootstrap";
import { SectionTitle } from "@/components/pieces/text/SectionTitle";
import { Subtitle } from "@/components/pieces/text/Subtitle";
import { Card, CardContent } from "@/components/ui/card";

import { SettingsHeader } from "./SettingsHeader";

function WorkspaceIntegrationsInner() {
  return (
    <Container>
      <SettingsHeader>Integrations</SettingsHeader>
      <Card>
        <CardContent>
          <Box mb={2}>
            <SectionTitle>Call Recorders</SectionTitle>
          </Box>
          <Box mb={4}>
            <Subtitle>Automatically import your calls into Exec</Subtitle>
          </Box>

          <FirefliesIntegration />

          <Box mt={3}>
            <GongIntegration />
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}

export function WorkspaceIntegrations() {
  return (
    <Authenticate
      requireWorkspaceAgent={true}
      requireWorkspaceAdmin={true}
      maxWidth="100%"
      layout="settings"
    >
      <SettingsLayout>
        <WorkspaceIntegrationsInner />
      </SettingsLayout>
    </Authenticate>
  );
}
